<template>
  <ul class="list">
    <li class="line">
      <div class="circle green"></div>
      <div class="inline">Produção</div>
    </li>
    <li class="line">
      <div class="circle red"></div>
      <div class="inline">Parada</div>
    </li>
    <li class="line">
      <div class="circle cyan"></div>
      <div class="inline">Setup</div>
    </li>
    <li class="line">
      <div class="circle blue"></div>
      <div class="inline">Ocioso</div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Legenda"
};
</script>

<style scoped>
.list {
  font-size: 12px;
  text-decoration: none;
}
li {
  display: flex;
  align-items: center;
  margin-left: 1em;
}

li:not(:last-child) {
  margin-bottom: 0.5em;
}

.circle {
  display: inline-block;
  height: 12px;
  width: 12px;
  border-radius: 50%;
}
.inline {
  margin-left: 0.5em;
  display: inline-block;
}

.green {
  background-color: var(--color-success);
}
.red {
  background-color: var(--color-stop);
}
.cyan {
  background-color: var(--color-setup);
}
.blue {
  background-color: var(--color-danger);
}
</style>
